
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M920.598 419.931H578.873V78.387a56.894 56.894 0 10-113.698 0v341.544h-340.73a56.894 56.894 0 100 113.698h340.82V874.54a56.894 56.894 0 00113.789 0V533.448h341.544a56.804 56.804 0 100-113.517z"}})])
          )
        }
      }
    